import { createUniqueId } from 'solid-js'

export function TimeGuardIcon() {
  // Minted per instance, so copies of one icon never resolve url(#…) to
  // each other's defs
  const id = createUniqueId()
  const paint0 = `time-guard-icon-${id}-paint0`
  const paint1 = `time-guard-icon-${id}-paint1`
  const clip0 = `time-guard-icon-${id}-clip0`

  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g clip-path={`url(#${clip0})`}>
        <path
          d="M23.115 43.4233C21.955 43.4233 20.785 43.1333 19.755 42.5833L13.255 39.1233C8.54498 36.6133 5.60498 31.7333 5.60498 26.3933V14.7533C5.61498 10.4433 8.83498 6.75329 13.105 6.16329L15.475 5.84329L18.775 3.67329C20.065 2.83329 21.565 2.37329 23.105 2.37329C24.645 2.37329 26.145 2.82329 27.425 3.67329L30.725 5.84329L33.095 6.16329C37.365 6.75329 40.595 10.4433 40.595 14.7633V26.4033C40.595 31.7433 37.665 36.6233 32.945 39.1333L26.445 42.5933C25.415 43.1433 24.255 43.4233 23.085 43.4233H23.115Z"
          fill={`url(#${paint0})`}
        />
        <path
          d="M36.445 14.7534V26.3934C36.445 30.1834 34.355 33.6634 31.005 35.4434L24.505 38.9034C23.625 39.3634 22.575 39.3634 21.705 38.9034L15.205 35.4434C11.855 33.6634 9.76495 30.1834 9.76495 26.3934V14.7534C9.76495 12.5034 11.435 10.5934 13.655 10.2834L16.295 9.92339C16.735 9.86339 17.155 9.70339 17.535 9.46339L21.065 7.14339C22.305 6.33339 23.905 6.33339 25.145 7.14339L28.675 9.46339C29.045 9.71339 29.465 9.86339 29.915 9.92339L32.555 10.2834C34.785 10.5934 36.445 12.4934 36.445 14.7534Z"
          fill={`url(#${paint1})`}
        />
        <path
          d="M23.115 27.7332C22.315 27.7332 21.655 27.0832 21.655 26.2732V24.3432H19.725C18.925 24.3432 18.265 23.6932 18.265 22.8832C18.265 22.0732 18.915 21.4232 19.725 21.4232H21.655V19.4932C21.655 18.6932 22.305 18.0332 23.115 18.0332C23.925 18.0332 24.575 18.6832 24.575 19.4932V21.4232H26.505C27.305 21.4232 27.965 22.0732 27.965 22.8832C27.965 23.6932 27.315 24.3432 26.505 24.3432H24.575V26.2732C24.575 27.0732 23.925 27.7332 23.115 27.7332Z"
          fill="#68E700"
        />
        <path
          d="M41.255 34.66L41.975 33.94C43.795 32.12 43.795 29.17 41.975 27.36C41.095 26.48 39.925 26 38.685 26C37.445 26 36.275 26.48 35.395 27.36L34.675 28.08L33.955 27.36C33.075 26.48 31.905 26 30.665 26C29.425 26 28.245 26.47 27.365 27.35C25.555 29.17 25.555 32.12 27.365 33.94L28.085 34.66L27.365 35.38C25.545 37.2 25.545 40.15 27.365 41.96C28.245 42.84 29.415 43.32 30.655 43.32C31.895 43.32 33.065 42.84 33.945 41.96L34.665 41.24L35.385 41.96C36.265 42.84 37.435 43.32 38.675 43.32C39.915 43.32 41.085 42.84 41.965 41.96C43.785 40.14 43.785 37.19 41.965 35.38L41.245 34.66H41.255Z"
          fill="white"
        />
        <path
          d="M37.665 34.6601L40.185 32.1401C41.015 31.3101 41.015 29.9701 40.185 29.1501C39.355 28.3301 38.015 28.3201 37.195 29.1501L34.675 31.6701L32.155 29.1501C31.325 28.3201 29.985 28.3201 29.165 29.1501C28.345 29.9801 28.335 31.3201 29.165 32.1401L31.685 34.6601L29.165 37.1801C28.335 38.0101 28.335 39.3501 29.165 40.1701C29.575 40.5801 30.115 40.7901 30.665 40.7901C31.215 40.7901 31.745 40.5801 32.165 40.1701L34.685 37.6501L37.205 40.1701C37.615 40.5801 38.155 40.7901 38.705 40.7901C39.255 40.7901 39.785 40.5801 40.205 40.1701C41.035 39.3401 41.035 38.0001 40.205 37.1801L37.685 34.6601H37.665Z"
          fill="#FF3F6F"
        />
      </g>
      <defs>
        <linearGradient
          id={paint0}
          x1="23.115"
          y1="39.7733"
          x2="23.115"
          y2="3.93329"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00E300" />
          <stop offset="0.52" stop-color="#00FC00" stop-opacity="0.89" />
          <stop offset="0.68" stop-color="#17FC00" stop-opacity="0.92" />
          <stop offset="1" stop-color="#8CFC00" />
        </linearGradient>
        <linearGradient
          id={paint1}
          x1="23.115"
          y1="42.5134"
          x2="23.115"
          y2="5.46339"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#035A15" />
          <stop offset="1" stop-color="#00C800" />
        </linearGradient>
        <clipPath id={clip0}>
          <rect width="46" height="46" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
